// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4V2b2","photo":"styles_photo__Pq+mI"};